import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Activities from "../pages/activities/page";
import ActivityDetail from "../pages/activities/detail/page";
import Rules from "../pages/rules/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/activities",
    element: <Activities />,
  },
  {
    path: "/activities/:id",
    element: <ActivityDetail />,
  },
  {
    path: "/rules",
    element: <Rules />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;